import React, { useState, useEffect } from 'react';
import { Upload, Form, Input } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import notification from '../../../elements/lib/NotificationWrapper';
import { Translation, getI18n } from 'react-i18next';

// upload criteria
const fileTypesImage = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
};

const fileSizeLimit = 1024 * 1024 * 6;

const MediaUpload = ({
  form,
  field,
  media,
  media_id,
  getSignedUrl,
  setDeleteImageIds,
  deleteImageIds,
}) => {
  const [uploadedMedia, setUploadedMedia] = useState(null);

  const propsMedia = {
    multiple: false,
    onChange(info) {
      const fileList = info.fileList;
      setUploadedMedia(fileList);

      const modulesArr = form.getFieldValue('modules') || [];
      modulesArr[field.name] = {
        ...(modulesArr[field.name] || {}),
        media: fileList,
      };

      form.setFieldsValue({ modules: modulesArr });
      form.validateFields([['modules', field.name, 'media']]);
    },
    beforeUpload(file) {
      const isSupportedFileType = Object.keys(fileTypesImage).includes(
        file.type
      );
      if (!isSupportedFileType) {
        notification.error(
          getI18n().t('learning_admin_form_input_media_file_types')
        );
        setUploadedMedia(null);
        return Upload.LIST_IGNORE;
      }
      const isUnderFileSizeLimit = file.size < fileSizeLimit;
      if (!isUnderFileSizeLimit) {
        notification.error(
          getI18n().t('learning_admin_form_input_image_file_size_limit')
        );
        setUploadedMedia(null);
        return Upload.LIST_IGNORE;
      }
      return false;
    },
  };

  const handleRemove = () => {
    if (media && media_id) {
      if (deleteImageIds.includes(media_id) === false) {
        setDeleteImageIds([...deleteImageIds, media_id]);
      }
    }

    setUploadedMedia(null);
    const modulesArr = form.getFieldValue('modules') || [];
    modulesArr[field.name] = {
      ...(modulesArr[field.name] || {}),
      media: undefined,
      media_id: undefined,
    };
    form.setFieldsValue({ modules: modulesArr });
    form.validateFields([['modules', field.name, 'media']]);
  };

  useEffect(() => {
    if (media && media.id) {
      if (
        media['file_directory'] &&
        media['file_name'] &&
        media['file_extension']
      ) {
        const size = 160;
        const path = `ratio/${size}x${size}/${media['file_directory']}/${media['file_name']}.${media['file_extension']}`;

        getSignedUrl(path, (success, signedUrl) => {
          if (success) {
            const defaultFile = [
              {
                uid: media['id'],
                name: media['file_name'],
                url: signedUrl,
                thumbUrl: signedUrl,
                status: 'done',
              },
            ];
            setUploadedMedia(defaultFile);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [media]);

  return (
    <Translation>
      {(t) => (
        <>
          <div className='form-group'>
            <Form.Item
              name={[module.name, 'cover_image_id']}
              style={{ display: 'none' }}
            >
              <Input type='hidden' />
            </Form.Item>
          </div>

          <div className='form-group'>
            <div
              className='ant-col ant-col-24 ant-form-item-label'
              style={{ paddingBottom: 0 }}
            >
              <label className='ant-form-item-required'>
                {t('learning_admin_form_input_media')}
              </label>
            </div>
            <Form.Item
              name={[field.name, 'media']}
              fieldKey={[field.fieldKey, 'media']}
              rules={[
                { required: true, message: 'Missing data for required field.' },
              ]}
            >
              {uploadedMedia === null || uploadedMedia.length === 0 ? (
                <Upload.Dragger {...propsMedia}>
                  <p className='ant-upload-drag-icon'>
                    <InboxOutlined />
                  </p>
                  <p className='ant-upload-text'>
                    {t('learning_admin_form_input_image_drag_and_drop_upload')}
                  </p>
                  <p className='ant-upload-hint'>
                    {t('learning_admin_form_input_image_drag_and_drop_types')}
                  </p>
                </Upload.Dragger>
              ) : (
                <Upload
                  className='upload-file'
                  fileList={uploadedMedia}
                  listType='picture'
                  multiple={false}
                  onRemove={handleRemove}
                />
              )}
            </Form.Item>
          </div>
        </>
      )}
    </Translation>
  );
};

export default MediaUpload;
